<template>
  <div :class="rootClass">
    <div v-if="isShowErrNoti" class="font-medium-4 errMsg">
      <div class="d-flex flex-column">
        <img v-if="isErrPopup"
             src="@/assets/images/icons/x-circle.svg" style="width: 100px;height: 100px;margin-left: 40%;margin-bottom: 5%">
        <p v-else class="mb-2" style="color: black; font-weight: bold; font-size: 28px; text-align: center">Thông
          báo</p>
        <p style="font-size: 21px;font-weight: 700;line-height: 36px;text-align: center;">{{ notiContent }}</p>
        <button class="buttonOK" style="margin-left: 30%;" @click="isShowErrNoti=false">OK</button>
      </div>
    </div>
    <div v-if="isShowConfirm" class="font-medium-4 errMsg">
      <div class="d-flex flex-column">
        <p class="mb-2" style="color: black; font-weight: bold; font-size: 28px; text-align: center">Thông báo</p>
        <p style="font-size: 21px;font-weight: 700;line-height: 36px;text-align: center;">{{ confirmContent }}</p>
        <div class="d-flex justify-content-around mt-2">
          <button class="buttonOK" @click="provisionPackage()">Đồng ý</button>
          <button class="buttonOK" @click="isShowConfirm=false">Hủy</button>
        </div>
      </div>
    </div>
    <b-row align-v="center" class="mb-2">
      <label :class="rootClass + '__search-subscriber-label'"
      >Số thuê bao</label
      >
      <b-input-group :class="[rootClass + '__search-input-group',inputErr?'inputErr':'']">
        <b-input-group-prepend :class="rootClass + '__search-icon'">
          <feather-icon icon="SearchIcon" size="21"/>
        </b-input-group-prepend>
        <b-form-input
            ref="inputSearchPhone"
            v-model="searchPhoneInput"
            :class="rootClass + '__search-input'"
            placeholder="Tìm kiếm"
            size="lg"
            v-on:keyup.enter="getSubscriberStatus(searchPhoneInput)"
        >
        </b-form-input>
      </b-input-group>
      <b-button :class="rootClass + '__search-btn'" class="redButton" variant="danger"
                @click="getSubscriberStatus(searchPhoneInput)"
      >Tra cứu
      </b-button
      >
    </b-row>
    <b-row>
      <table :class="rootClass + '__search-table'" class="data">
        <tr style="height: 3rem">
          <template v-for="(h, i) in fields"
          >
            <th
                :key="h.key"
                :class="{
                  '--first-th': i === 0,
                  '--last-th': i === fields.length - 1,
                }"
            >
              {{ h.label }}
            </th>
          </template
          >
        </tr>
        <template v-for="(r,index) in pkg_allowance" v-if="showErrSearch===false">
          <tr
              :key="index"
              style="height: 3rem; border-top: 0.629766px solid #efefef;"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ searchPhone }}</td>
            <td>{{ r.name }}</td>
            <td>{{ r.period > 0 ? r.period + " ngày" : "" }}</td>
            <td>{{ r.group_name }}</td>
            <td>{{ new Intl.NumberFormat('vi-VN', {style: 'currency', currency: 'VND'}).format(r.price) }}</td>
            <td style="text-align: left;width: 40%;padding-left: 5px;line-height: 1.6" v-html="r.description"></td>
            <td>
              <button class="registerButton redButton" @click="showConfirmPopUp(r)">Mở gói</button>
            </td>
          </tr>
        </template>
        <tr v-if="showErrSearch">
          <td></td>
          <td></td>
          <td>{{ notiContent }}</td>
        </tr>
      </table>
    </b-row>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import DropMenu from "./DropMenu.vue";
import useJwt from "@/auth/jwt/useJwt";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BModal,
    BFormGroup,
    BFormCheckbox,
    BImg,
    BButtonGroup,
    BInputGroup,
    BInputGroupPrepend,
    DropMenu,
  },
  data() {
    return {
      rootClass: "search-package",
      fields: [
        {key: "stt", label: "STT"},
        {key: "phoneNumber", label: "Số thuê bao"},
        {key: "SERVICE_CODE", label: "Tên gói cước"},
        {key: "packageCycle", label: "Chu kỳ gói"},
        {key: "packageType", label: "Loại gói"},
        {key: "packagePrice", label: "Giá gói"},
        {key: "description", label: "Ưu đãi"},
        {key: "action", label: "#"},
      ],
      pkg_allowance: {},
      searchPhoneInput: "",
      regex087: /87\d{7}$/,
      inputErr: false,
      showErrSearch: false,
      isErrPopup: false,
      isShowErrNoti: false,
      isShowConfirm: false,
      packageWillActive: "",
      notiContent: "",
      confirmContent: "",
      provisionPackageResult: {}
    };
  },
  props: {
    searchPhone: String
  },
  mounted() {
    this.searchPhoneInput = this.searchPhone
    this.getSubscriberStatus(this.searchPhone)
  },
  methods: {
    formatPhoneNum() {
      if (this.searchPhoneInput.startsWith("0")) {
        this.searchPhoneInput = this.searchPhoneInput.substring(1);
        this.searchPhoneInput = 84 + this.searchPhoneInput;
        this.searchPhone = this.searchPhoneInput;
      }
      if (this.searchPhoneInput.startsWith("84")) {
        this.searchPhone = this.searchPhoneInput;
      }
    },
    getSubscriberStatus(searchPhone) {
      try {
        useJwt.get('get_subscriber_status/' + searchPhone).then((response) => {
          this.subscriberStatus = response.data.result.result;
          if (this.subscriberStatus.ic === 'D' && this.subscriberStatus.oc === 'D') {
            this.showErrSearch = true
            this.isShowErrNoti = true
            this.notiContent = "Số thuê bao đang khóa 2 chiều, vui lòng mở khóa để sử dụng tính năng"

          } else {
            this.searchPKLAllowance(searchPhone)
          }
        }).catch((error) => {
          console.log(error);
        });
      } catch (e) {
        console.log(e)
      }
    },
    showConfirmPopUp(dependencyPackage) {
      this.packageWillActive = dependencyPackage
      this.isShowConfirm = true;
      this.confirmContent = "Bạn có chắc muốn đăng ký gói cước " + this.packageWillActive.name + ", giá gói " + this.packageWillActive.price + " đồng cho số thuê bao " + this.searchPhone;
    },
    provisionPackage() {
      this.isShowConfirm = false
      useJwt.post('provision-package?msisdn=' + this.searchPhone + '&packageCode=' + this.packageWillActive.name + '&action=on&comment=Mo-goi-theo-yeu-cau').then((response) => {
        this.provisionPackageResult = response.data.result.result;
        this.isShowErrNoti = true
        this.isErrPopup = false;
        this.notiContent = this.provisionPackageResult.statusMessage.slice(6)
        // console.log("provision", this.provisionPackageResult)
      }).catch((err) => {
        // console.log("message",err.response.data.message)
        this.isShowErrNoti = true
        this.isErrPopup = false;
        this.notiContent = err.response.data.message
      })
    },
    searchPKLAllowance(searchPhone) {
      this.showLoading("block")
      this.formatPhoneNum()
      if (this.regex087.test(searchPhone)) {
        this.inputErr = false,
            useJwt.get('check_pkg_allowance/:msisdn?msisdn=' + searchPhone).then((response) => {
              this.showLoading("none")
              this.pkg_allowance = response.data.result;

              if (typeof this.pkg_allowance === "string") {
                this.showErrSearch = true
                this.isShowErrNoti = true
                this.isErrPopup = true
                this.notiContent = "Không lấy được dữ liệu"
              } else {
                if (this.pkg_allowance.length === 0) {
                  this.isShowErrNoti = true
                  this.isErrPopup = true
                  this.notiContent = "Không có dữ liệu về gói cước đăng kí được"
                } else {
                  this.isShowErrNoti = false
                  this.showErrSearch = false

                }
              }
            }).catch((error) => {
              this.showLoading("none")
              this.pkg_allowance = {}
              this.isShowErrNoti = true
              this.isErrPopup = true
              this.notiContent = "Không lấy được dữ liệu"
              console.log(error);
            });
      } else {
        this.showLoading("none")
        this.$refs.inputSearchPhone.focus()
        this.pkg_allowance = {}
        if (this.searchPhoneInput === '') {
          this.isShowErrNoti = true;
          this.isErrPopup = true
          this.notiContent = "Vui lòng nhập số thuê bao"
        } else {
          this.isShowErrNoti = true;
          this.isErrPopup = true
          this.notiContent = "Số thuê bao chưa hợp lệ"
        }
        this.inputErr = true
      }
    },
    showLoading(options) {
      document.getElementById('loading-bg').style.display = options;
    }
  }
};
</script>

<style lang="scss" scoped>
.search-package {
  font-family: "Times New Roman";
  font-size: 16px;
  font-weight: 500;
  min-height: 500px;

  &__card {
    border-radius: 2rem;
  }

  &__func-group-btns {
    border: 1px solid red;
    border-radius: 40px;
    height: 38px;
  }

  &__subscriber-information-btn {
    border-radius: 40px;
    font-weight: 800;
    color: #707070 !important;
    background: transparent !important;
    border: transparent;
    padding: 0.2rem 1.5rem;
  }

  &__search-package-btn {
    border-radius: 40px !important;
    color: white;
    width: 195px;
    padding: 0.2rem 1.5rem;
  }

  &__search-subscriber-label {
    margin-right: 1rem;
    font-weight: 500;
  }

  &__search-input-group {
    width: 200px;
    margin-right: 3rem;
  }

  &__search-icon {
    position: absolute;
    z-index: 4;
    top: 50%;
    left: 1rem;
    transform: translate(0%, -50%);
  }

  &__search-input {
    padding-left: 3rem;
    border: 1.125px solid #e1e1e1 !important;
    border-radius: 6px !important;
  }

  &__search-btn {
    border-radius: 40px !important;
    color: white;
  }

  &__search-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;
  }

  &__menu-right-group {
    position: absolute;
    top: 140px;
    right: 20px;
  }
}

.inputErr {
  border: 1px red solid;
}

.redButton {
  background-color: #ED1F24 !important;
  border-color: #ED1F24 !important;
}

.registerButton {
  color: white;

}

tr td {
  color: black;
}

tr th,
tr td {
  border: 0.299185px solid rgba(184, 184, 184, 0.5);
  //border-left: 0.299185px solid rgba(184, 184, 184, 0.5);
}

th {
  background-color: #ED1F24;
  color: white;
}

.errMsg {
  padding: 1%;
  height: 300px;
  width: 445px;
  position: fixed;
  background-color: white;
  z-index: 10;
  top: 30%;
  left: 35%;
  border-radius: 13.24px;
  box-shadow: 5px 10px 18px #888888;
}

.buttonOK {
  width: 164.88px;
  height: 44.17px;
  left: 638px;
  top: 400px;
  background: #ED1F24;
  border-radius: 23.6547px;
  border-color: #ED1F24;
  color: white;
}

@media screen and (max-width: 576px) {
  .search-package {
    &__subscriber-information-btn {
      font-size: 12px;
    }

    &__search-package-btn {
      font-size: 12px;
    }

    &__search-subscriber-label {
      width: 100%;
    }

    &__search-input-group {
      margin-right: 1rem;
      width: 170px;
    }

    &__search-table {
      font-size: 8px;
    }
  }
}
</style>
